<template>
  <ValidationObserver v-slot="{handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal
        size="md" :visible="modal.show" :data="model" :show-confirmation="showConfirmation" :ok-title="$t('Submit')"
        :title="model.uuid ? $t(`Update City`) : $t(`Create New City`)" :is-loading="loading" scrollable
        @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)">
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="name"/>
        </div>
        <div class="col-md-12">
          <state-input-widget
              :model="model" attribute="state_uuid" :items="states" @select="onStateSelect" @unselect="onStateUnselect">
          </state-input-widget>
        </div>
        <div class="col-md-12">
          <county-input-widget :model="model" attribute="county_uuid" :select2-items="counties" is-select2/>
        </div>
        <div class="col-md-12">
          <percentage-input-widget :model="model" attribute="tax_rate"/>
        </div>
        <div class="col-md-12">
          <input-widget :model="model" attribute="exclude_tax_for_premium" type="checkbox"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import PercentageInputWidget from "../../../core/widgets/PercentageInputWidget";
  import CityModel from "./models/City.model";
  import CountyInputWidget from "../../../core/widgets/CountyInputWidget";
  import StateInputWidget from "../../../core/widgets/StateInputWidget";
  import {GeographicStructureHelper} from "../../../core/services/geographicStructureHelper";

  const {mapState, mapActions} = createNamespacedHelpers('setup/salesTaxConfiguration');
  export default {
    name: "CityModal",
    components: {
      StateInputWidget,
      CountyInputWidget,
      PercentageInputWidget,
      InputWidget,
      ArtisioModal,
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new CityModel(),
        counties: [],
      }
    },
    computed: {
      ...mapState({
        modal: state => state.city.modal,
        editObject: state => state.city.modal.object,
        states: state => state.state.countryStates,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && (this.editObject.uuid || this.editObject.county_uuid)) {
          this.model = new CityModel(this.editObject);
          if (this.editObject.county) {
            this.model.state_uuid = this.editObject.county.state_uuid;
            this.onStateSelect(this.editObject.county.state, false);
          }
        }
      },
    },
    methods: {
      ...mapActions(['hideCityModal', 'createCity', 'updateCity']),
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new CityModel();
        this.hideCityModal();
      },
      async onSubmit() {
        this.loading = true;

        const isUpdate = !!this.model.uuid;
        const params = _.cloneDeep(this.model.toJSON());
        let response;

        if (isUpdate) {
          response = await this.updateCity(params);
        } else {
          response = await this.createCity(params);
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideCityModal();
          if (isUpdate) {
            this.$toast('success', this.$t('City was successfully updated'));
          } else {
            this.$toast('success', this.$t('City was successfully created'));
          }
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      async onStateSelect(state, clearCounty = true) {
        if (clearCounty) {
          this.model.county_uuid = null;
        }
        const {success, body} = await GeographicStructureHelper.getCountiesByState({
          load_all: true,
          state_uuid: state.uuid
        });
        if (success) {
          this.counties = _.cloneDeep(body || []);
        }
      },
      onStateUnselect() {
        this.model.state_uuid = null;
        this.model.county_uuid = null;
        this.counties = [];
      },
    },
  }
</script>

<style scoped>

</style>